import * as actionType from "../constants/actionTypes";

const mastersReducer = (state = { mastersData: null }, action) => {
  switch (action.type) {
    case actionType.CATEGORIES:
      return { ...state, categories: action.payload };
    
   

    case actionType.ROLELIST:
      return { ...state, role_list: action.payload };
    case actionType.UNITS:
      return { ...state, units: action.payload };
    default:
      return state;
  }
};

export default mastersReducer;
